import { Component } from "solid-js";

interface BrowseIconProps {
  class?: string;
}

export const BrowseIcon: Component<BrowseIconProps> = (props) => {
  return (
    <svg
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      class={props.class}
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M13.5996 5.19995V12.3996C13.5996 13.0626 12.9961 13.5996 12.2511 13.5996H5.34844C4.60343 13.5996 4 13.0626 4 12.3996V5.19995C4 4.53698 4.60343 4 5.34844 4H12.2518C12.9961 4 13.5996 4.53698 13.5996 5.19995Z"
        class="stroke-inherit"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M13.5996 19.6004V26.8001C13.5996 27.4631 12.9961 28 12.2511 28H5.34844C4.60343 28 4 27.4631 4 26.8001V19.6004C4 18.9374 4.60343 18.4005 5.34844 18.4005H12.2518C12.9961 18.4005 13.5996 18.9374 13.5996 19.6004Z"
        class="stroke-inherit"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M27.999 5.19995V12.3996C27.999 13.0626 27.3956 13.5996 26.6505 13.5996H19.7479C19.0028 13.5996 18.3994 13.0626 18.3994 12.3996V5.19995C18.3994 4.53698 19.0028 4 19.7479 4H26.6512C27.3956 4 27.999 4.53698 27.999 5.19995Z"
        class="stroke-inherit"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M27.999 19.6004V26.8001C27.999 27.4631 27.3956 28 26.6505 28H19.7479C19.0028 28 18.3994 27.4631 18.3994 26.8001V19.6004C18.3994 18.9374 19.0028 18.4005 19.7479 18.4005H26.6512C27.3956 18.4005 27.999 18.9374 27.999 19.6004Z"
        class="stroke-inherit"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
